import { useGetUserNameWithFallback } from '@pba/react-utils';
import type { UserBase } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { routes } from 'routes/routes';
import type { MemberEntityScope } from '../types';
import { useGetMemberBreadcrumbEntityName } from './useGetMemberBreadcrumbEntityName';

export const useGetMemberEntityBreadcrumb = ({
  entityScope,
  member,
}: {
  entityScope: MemberEntityScope;
  member: UserBase;
}) => {
  const { t } = useTranslation();
  const getEntityName = useGetMemberBreadcrumbEntityName();
  const getUserNameWithFallback = useGetUserNameWithFallback();

  return useMemo(
    () => [
      {
        path: routes.members.detail(member.id),
        title: getUserNameWithFallback(member),
      },
      {
        path: routes.members.entities(member.id, entityScope),
        title: t(getEntityName({ entityScope })),
      },
    ],
    [getEntityName, entityScope, getUserNameWithFallback, member, t],
  );
};
